module.exports = __webpack_public_path__ + "img/home-product-compare.5cd850a9.png";